import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Avatar,AvatarImage, AvatarFallback } from './ui/avatar';
import { Mail, Phone, Linkedin, Github, Download, MapPin } from 'lucide-react';
import { toast } from 'sonner';

export const Hero = () => {
  const stats = [
    { label: 'Years Experience', value: '10+' },
    { label: 'Projects Completed', value: '10+' },
    { label: 'Technologies', value: '20+' },
  ];

  const handleDownloadResume = () => {
    toast.success('Resume download started');
    // Mock download functionality
    const link = document.createElement('a');
    link.href = '#';
    link.download = 'Satyendra_Resume.pdf';
    link.click();
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-16">
      {/* Animated Background */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-primary/20 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto text-center">
          {/* Avatar */}
          <div className="mb-8 animate-fade-in-up">
            <Avatar className="w-32 h-32 sm:w-40 sm:h-40 mx-auto border-4 border-primary shadow-glow">
               <AvatarImage 
                src="/sdimage.jpeg" 
                alt="Satyendra" 
                className="object-cover"
              />
              <AvatarFallback className="text-4xl sm:text-5xl font-bold bg-gradient-azure text-primary-foreground">
                CS
              </AvatarFallback>
            </Avatar>
          </div>

          {/* Name & Title */}
          <div className="space-y-4 mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
            <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold">
              Ch Satyendra
            </h1>
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-gradient-azure">
              Senior Full-Stack .NET & Azure Developer
            </h2>
            <p className="text-base sm:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto">
              Building scalable cloud applications with .NET Core, JS & Azure with strong AI skills.
            </p>
          </div>

          {/* Location & Contact Icons */}
          <div className="flex flex-wrap items-center justify-center gap-4 mb-8 animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
            <Badge variant="secondary" className="px-4 py-2 text-sm sm:text-base">
              <MapPin className="w-4 h-4 mr-2" />
              Hyderabad, India
            </Badge>
            <div className="flex items-center gap-2">
              <Button
                variant="outline"
                size="icon"
                className="rounded-full"
                onClick={() => window.location.href = 'tel:+919885889495'}
              >
                <Phone className="h-4 w-4" />
              </Button>
              <Button
                variant="outline"
                size="icon"
                className="rounded-full"
                onClick={() => window.location.href = 'mailto:satyendra.chittampalli@gmail.com'}
              >
                <Mail className="h-4 w-4" />
              </Button>
              <Button
                variant="outline"
                size="icon"
                className="rounded-full"
                onClick={() => window.open('https://www.linkedin.com/in/satyendra-chittampalli-b13181b7/?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BJ%2BMRB8sZRZSjKc8V%2BZSF%2Bw%3D%3D', '_blank')}
              >
                <Linkedin className="h-4 w-4" />
              </Button>
              <Button
                variant="outline"
                size="icon"
                className="rounded-full"
                onClick={() => window.open('https://github.com/Satyendrach1', '_blank')}
              >
                <Github className="h-4 w-4" />
              </Button>
            </div>
          </div>

          {/* CTA Button */}
          <div className="mb-12 animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
            <Button
              size="lg"
              className="gradient-azure text-primary-foreground hover:shadow-glow transition-all duration-300 text-base sm:text-lg px-6 sm:px-8 py-5 sm:py-6"
              onClick={handleDownloadResume}
            >
              <Download className="mr-2 h-5 w-5" />
              Download Resume
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 sm:gap-8 max-w-3xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.8s' }}>
            {stats.map((stat, index) => (
              <div
                key={index}
                className="glass-card p-4 sm:p-6 rounded-xl hover:shadow-elegant transition-all duration-300"
              >
                <div className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gradient-azure mb-2">
                  {stat.value}
                </div>
                <div className="text-xs sm:text-sm text-muted-foreground">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};